import { create } from "zustand";
import { devtools } from "zustand/middleware";

import {
  AccountAnalysisConfiguration,
  AnalysisEntity,
  AnalysisProfile,
  Lens,
  LensGroup
} from "../types";
import {
  ConfigurationActions,
  createConfigurationSlice,
  createEntitySlice,
  createLensSlice,
  createProfileSlice,
  EntityActions,
  LensActions,
  ProfileActions
} from "./actions";

export interface AccountAnalysisState {
  entities: AnalysisEntity[];
  isLoadingEntities: boolean;
  entitiesError: string | null;
  selectedEntityIds: string[];

  profiles: AnalysisProfile[];
  isLoadingProfiles: boolean;
  profilesError: string | null;
  selectedProfileIds: string[];

  lensGroups: LensGroup[];
  isLoadingLensGroups: boolean;
  lensGroupsError: string | null;
  selectedLensGroupName: string | null;

  lenses: Lens[];
  selectedLensPath: string | null;
  currentLensContent: string;

  configuration: AccountAnalysisConfiguration | null;
  isLoadingConfiguration: boolean;
  configurationError: string | null;
}

export type AccountAnalysisStore = AccountAnalysisState & EntityActions & ProfileActions & LensActions & ConfigurationActions;

export const useAccountAnalysisStore = create<AccountAnalysisStore>()(
  devtools(
    (set, get) => ({
      entities: [],
      isLoadingEntities: false,
      entitiesError: null,
      selectedEntityIds: [],

      profiles: [],
      isLoadingProfiles: false,
      profilesError: null,
      selectedProfileIds: [],

      lensGroups: [],
      isLoadingLensGroups: false,
      lensGroupsError: null,
      selectedLensGroupName: null,

      lenses: [],
      selectedLensPath: null,
      currentLensContent: "",

      configuration: null,
      isLoadingConfiguration: false,
      configurationError: null,

      ...createEntitySlice(set, get),
      ...createProfileSlice(set, get),
      ...createLensSlice(set, get),
      ...createConfigurationSlice(set, get)
    }),
    {
      name: "account-analysis-store"
    }
  )
);
